<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "BbmIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
